import { BodyM } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import Magnify from '@/components/Icon/Magnify'
import { ListingCate } from '@/page-commons/listingBySlug'
import { flexCenter, paddingBottom, gap } from '@/shared-styles/styles.css'
import filtersMapper from '@/utils/filters-mapper'
import { formatPrice } from '@/utils/format-currency'

import { box } from '../../styles.css'
import { FilterInfo } from '../Common/FilterInfo'
import { lightP } from '../styles.css'

import { getPriceMaxCents, getPriceMinCents } from './SaveSearchDetail'

export const FiltersBoxListingContact: React.FC<{ listing: ListingCate }> = ({ listing }) => {
  const { lang, t } = useTranslation()

  return (
    <div className={box}>
      <div className={[flexCenter, paddingBottom.m, gap.m].join(' ')}>
        <Magnify />
        <BodyM>{t('save-search:your_research')}</BodyM>
      </div>

      {listing.detail.sellingPrices && (
        <FilterInfo
          label={t('save-search:price')}
          value={filtersMapper.formatRange(
            formatPrice(
              {
                cents: getPriceMinCents(listing.detail.sellingPrices && listing.detail.sellingPrices.cents),
              },
              lang
            ),
            formatPrice(
              {
                cents: getPriceMaxCents(listing.detail.sellingPrices && listing.detail.sellingPrices.cents),
              },
              lang
            ),
            t
          )}
        />
      )}

      {!!listing.characteristics.rooms && (
        <div>
          <p className={lightP}>{t('save-search:features_title')}</p>

          <span>{`${listing.characteristics.rooms} ${t(
            listing.characteristics.rooms > 1 ? 'filter:rooms' : 'filter:room'
          )}`}</span>
        </div>
      )}
    </div>
  )
}
